import { useDispatch } from "react-redux";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";
import { ApiResponse } from "types/api";

import { TiVoDeviceClientType } from "./types";

export const useCreateClientType = (platformId?: string, oemId?: string) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation<
    ApiResponse<TiVoDeviceClientType>,
    Error,
    Partial<TiVoDeviceClientType>
  >({
    mutationFn: async (data) =>
      dispatch(
        apiThatThrows.createTiVoClientType.action({
          params: { oemId, platformId },
          options: {
            body: JSON.stringify({
              data: {
                type: "TiVoDeviceClientType",
                attributes: data,
              },
            }),
          },
        })
      ),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ["platforms"],
        }),
        queryClient.invalidateQueries({
          queryKey: ["oem", platformId, oemId],
        }),
      ]);
    },
  });
};
